import React from "react";
import photoPlaceholder from "../../../assets/img/profile/picture-placeholder.svg";
import { connect } from "react-redux";
import { mapStateToPropsLogin } from "../../../modules/login";

const UserImage = (props) => {
  const { userName, userRole, userPicture, className = "" } = props;

  const imageSrc = !userPicture ? photoPlaceholder : userPicture;

  return (
    imageSrc && (
      <img
        onClick={() => {
          props.callback();
        }}
        data-testid="test-userimage"
        src={imageSrc}
        alt={userName || "User photo"}
        className={`${(
          userRole || ""
        ).toLowerCase()} profile-picture img-fluid ${className}`}
      />
    )
  );
};

export default connect(mapStateToPropsLogin, null)(UserImage);
